import { useCallback, ReactNode } from 'react';
import { Icon } from '@octano/global-ui';

type ValidationFileChipProps<T = unknown> = {
  value: T;
  size?: 'md' | 'sm';
  children: ReactNode;
  onRemove?: (value: T) => void;
  onDownload?: () => void;
};

const ValidationFileChip = <T,>({
  value,
  children,
  onRemove,
  onDownload,
}: ValidationFileChipProps<T>) => {
  const handleRemove = useCallback(() => {
    if (!onRemove) {
      return;
    }
    onRemove(value);
  }, [value, onRemove]);

  return (
    <div
      className={`border p-2 rounded border-primary text-primary d-flex align-items-center`}
      style={{ gap: 12 }}
    >
      <span>{children}</span>

      {!!onRemove && (
        <button type="button" className="btn btn-sm p-0" onClick={handleRemove}>
          <Icon name="trash" size={12} />
        </button>
      )}
      {!!onDownload && (
        <button type="button" className="btn btn-sm p-0" onClick={onDownload}>
          <Icon name="download" size={12} />
        </button>
      )}
    </div>
  );
};

export default ValidationFileChip;
